import { Box, Modal } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BANNER_SEEN_DATE } from "../../constants/global";
import { routes } from "../../constants/routes";
import { StockFilters } from "../../constants/stock-attributes";
import siteImages from "../../data/siteImages";
import { setItem } from "../../utils/storage";
import { route } from "../../utils/utilities";
import Button, { ButtonSize, ButtonVariant } from "../utils/Button";
import NavButton from "../utils/NavButton";

export const BannerModal = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const bannerDesktop = siteImages.bannerDesktop;
  const bannerMobile = siteImages.bannerMobile;
  const bannerCta = (siteImages.bannerCta as Record<string, string>)[lang];

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if ((bannerDesktop?.src || bannerMobile?.src) && bannerCta) {
      setOpen(true);
    }
  }, [bannerDesktop, bannerMobile, bannerCta]);

  const handleClose = () => {
    setOpen(false);
    setItem(BANNER_SEEN_DATE, dayjs().format());
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      sx={{
        "& .MuiModal-backdrop": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          backdropFilter: "blur(10px)"
        }
      }}>
      <Box
        sx={{
          position: "fixed",
          top: { xs: "30%", md: "20%" },
          width: "100%",
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          outline: "none"
        }}>
        {/* DESKTOP */}
        <Box
          component={"img"}
          src={bannerDesktop?.src ?? bannerMobile?.src}
          alt={bannerDesktop?.alt ?? bannerMobile?.alt}
          sx={{
            width: "100%",
            maxWidth: "1600px",
            height: "auto",
            display: { xs: "none", md: "block" },
            p: 6
          }}
        />

        {/* MOBILE */}
        <Box
          component={"img"}
          src={bannerMobile?.src ?? bannerDesktop?.src}
          alt={bannerMobile?.alt ?? bannerDesktop?.alt}
          sx={{
            width: "100%",
            height: "auto",
            display: { xs: "block", md: "none" },
            p: 4
          }}
        />

        <Box display="flex" flexDirection={{ xs: "column-reverse", md: "row" }} gap={2}>
          <Button
            onClick={handleClose}
            label={t("buttons.close")}
            variant={ButtonVariant.accent}
            size={ButtonSize.full}
            sx={{
              width: "12rem"
            }}
          />

          <NavButton
            onClick={handleClose}
            route={route(routes.products, {
              [StockFilters.Discount]: true,
              [StockFilters.Discontinued]: true
            })}
            label={bannerCta}
            variant={ButtonVariant.primary}
            size={ButtonSize.full}
            forceThemeMode="dark"
            sx={{
              width: "12rem"
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};
